import React, { useState } from 'react';

const faqs = [
    {
        q: "How long does implementation typically take?",
        a: "Most facilities are up and running within 2-4 weeks, depending on the complexity of your current data and production lines."
    },
    {
        q: "Can OmniTrace integrate with my existing hardware?",
        a: "Yes! OmniTrace supports standard IoT protocols and can integrate with most weighing scales, barcode scanners, and PLC systems."
    },
    {
        q: "Is my data secure and compliant with local regulations?",
        a: "Absolutely. We use enterprise-grade encryption and maintain full compliance with FDA, EFSA, and local food safety legislative standards."
    },
    {
        q: "What kind of training do you provide for our shop floor staff?",
        a: "We provide comprehensive on-site and digital training materials, plus a simplified interface specifically designed for rapid shop-floor adoption."
    }
];

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <section id="faq" className="pt-8 pb-0 bg-white">
            <div className="section-padding max-w-4xl">
                <h2 className="heading-lg text-center mb-10">Frequently Asked Questions</h2>

                <div className="space-y-4">
                    {faqs.map((f, i) => (
                        <div key={i} className="border border-slate-100 rounded-2xl overflow-hidden hover:border-sky-200 transition-colors">
                            <button
                                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                                className="w-full flex justify-between items-center p-6 text-left hover:bg-slate-50 transition-colors"
                            >
                                <span className="text-lg font-bold text-slate-900">{f.q}</span>
                                <svg className={`w-5 h-5 text-sky-500 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            {openIndex === i && (
                                <div className="p-6 pt-0 text-slate-600 bg-slate-50 transition-all border-t border-slate-100">
                                    {f.a}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
